import {GetRegionByName, GetSubRegionByText, POOMSA, REGION} from '../defines/gukeo.const';
import {GetPoomSa} from '../defines/gukeo.func';
import {SimpleWord} from './simple-word.model';
import {IsEmptyString} from "../defines/common.func";
import {DIALECT_LIST_MEANING} from "../defines/desktop.const";


export class SimpleDialect {
  id: string;
  area1: string;
  area2: string;

  word: string; // 지방어
  word2: string;
  wordMore?: Array<string>;

  meaning2: Array<string> | null;
  bookmark: boolean;

  // TODO: 삭제예정. REGION 삭제시 모두 지울 것.
  region?: REGION;
  region2?: REGION;

  constructor(obj?: any) {
    this.id               = obj?.id                 ?? null;
    this.area1            = obj?.area1              ?? null;
    this.area2            = obj?.area2              ?? null;

    this.word             = obj?.word               ?? null;
    this.word2            = obj?.word2              ?? null;
    this.wordMore         = obj?.word_more          ? obj.word_more.split(',').map((value: string) => value.trim()) : null;

    this.meaning2         = obj?.meaning2           ? String(obj.meaning2).split('|') : null;
    this.bookmark         = obj?.bookmark           ?? null;

    if (this.area1) {
      this.region         = GetRegionByName(this.area1) || undefined;
    }
    if (this.area2) {
      const subInfo       = GetSubRegionByText(this.area2);
      this.region2        = subInfo?.region;
    }
  }

  public GetMeaning2Nth(nth: number): string | null {
    const meaning = this.meaning2?.[nth] ?? null;
    return IsEmptyString(meaning) ? null : meaning;
  }

  public getBreafMeanings(): Array<string> | null {
    // console.warn('getNumberedMeanings() ', dialect?.meaning2, dialect?.meaning2?.slice(1, DIALECT_LIST_MEANING + 1) ?? null);
    return this.meaning2?.slice(0, DIALECT_LIST_MEANING + 1) ?? null;
  }

  public getMoreMeanings(): number {
    // const more = Math.max(0, (dialect?.meaning2?.length ?? 0) - DIALECT_LIST_MEANING)
    // console.warn('getMoreMeanings() ', dialect?.meaning2?.length, more);
    return Math.max(0, (this.meaning2?.length ?? 0) - DIALECT_LIST_MEANING - 1);
  }
}

export class Dialect extends SimpleDialect {
  standardWord: string;
  standard?: SimpleWord;

  partOfSpeech?: Array<POOMSA> | null;
  meaning3: Array<string> | null;
  example2: Array<string> | null;
  example3: Array<string> | null;
  desc2: string;
  explanation3: Array<string> | null;

  dialects?: Array<SimpleDialect>;


  constructor(obj?: any) {
    super(obj);

    this.standardWord     = obj?.standard_word      ?? null;
    this.standard         = obj?.standard           ? new SimpleWord(obj.standard) : undefined;

    this.partOfSpeech     = obj?.part_of_speech     ? GetPoomSa(obj.part_of_speech) : null;
    this.meaning3         = obj?.meaning3           ? String(obj.meaning3).split('|') : null;
    this.example2         = obj?.example2           ? String(obj.example2).split('|') : null;
    this.example3         = obj?.example3           ? String(obj.example3).split('|') : null;
    this.desc2            = obj?.desc2              ?? null;
    this.explanation3     = obj?.explanation3       ? String(obj.explanation3).split('|') : null;

    if (obj?.dialects && Array.isArray(obj.dialects)) {
      this.dialects = new Array<SimpleDialect>();
      obj.dialects?.forEach((value: any) => this.dialects?.push(new SimpleDialect(value)));
    }
  }

  // this.aialects 에 자신을 포함시킨다.
  public get allDialects(): Array<SimpleDialect> {
    return this.dialects ? [this, ...this.dialects] : [this];
    //   new SimpleDialect({
    //     area1:    '경기도',
    //     word:     '경기말',
    //     word2:    '경기말',
    //     meaning2: '경기말 뜻',
    //   }),
    //   new SimpleDialect({
    //     area1:    '강원도',
    //     word:     '강원말',
    //     word2:    '강원말',
    //     meaning2: '강원말뜻',
    //   }),
    //   new SimpleDialect({
    //     area1:    '제주도',
    //     word:     '제주말',
    //     word2:    '제주말',
    //     meaning2: '제주말뜻',
    //   }),
    // ];
  }

  public GetMeaning3Nth(nth: number): string | null {
    const meaning = this.meaning3?.[nth] ?? null;
    return IsEmptyString(meaning) ? null : meaning;
  }

  /**
   * 예문 배열 가지고 오는 함수.
   * (규칙이 복잡함)
   * 뜻이 하나 있는 경우: 첫번째 예문 사용
   * 뜻이 두개 이상 있는 경우 (= 기본 뜻이 있는 경우): 기본 뜻에는 예문이 없다. 그래서 (예문 갯수 === 뜻 갯수 - 1)
   * @param nth
   * @constructor
   * @protected
   */
  public GetExample3Nth(nth: number): string | null {
    if ((this.meaning3?.length ?? 0) > 1) {
      // 뜻이 두개 이상인 경우
      // 뜻 0번은 기본 뜻이라서 예문이 없다.
      // 뜻 1번부터 예문이 있어서 -1을 해줌.
      const example = nth === 0 ? null : this.example3?.[nth - 1] ?? null;
      return IsEmptyString(example) ? null : example;
    }
    else {
      const example = this.example3?.[nth] ?? null;
      return IsEmptyString(example) ? null : example;
    }
  }

  public GetExplanation3Nth(nth: number): string | null {
    if ((this.meaning3?.length ?? 0) > 1) {
      const explanation = nth === 0 ? null : this.explanation3?.[nth - 1] ?? null;
      return IsEmptyString(explanation) ? null : explanation;
    }
    else {
      const explanation = this.explanation3?.[nth] ?? null;
      return IsEmptyString(explanation) ? null : explanation;
    }
  }

  private matchExample3(example3: string): RegExpMatchArray | null {
    // Construct a refined and potentially escaped regular expression
    // e.g., let's say you want to target strings like 'Word (captured content)'
    const refinedRegex = /^(.*)\s\((.*)\)$/;

    return example3 ? example3.match(refinedRegex) : null;
  }

  public GetExample3NthMain(nth: number): string | null {
    const example3 = this.GetExample3Nth(nth);
    if (example3) {
      const match = this.matchExample3(example3);

      // Corrected check for the number of capture groups
      return (match && match.length >= 1) ? match[1] : example3;
    }
    return null;
  }


  public GetExample3NthSub(nth: number): string | null {
    const example3 = this.GetExample3Nth(nth);
    if (example3) {
      const match = this.matchExample3(example3);

      // Corrected check for the number of capture groups
      return (match && match.length >= 2) ? match[2] : example3;
    }
    return null;
  }

  // protected get example3(): string | null {

  // }

  // protected get example3sub(): string | null {
  //   if (this.dialect?.example3) {
  //     const match = this.matchExample3;
  //     return match ? match[2] : null;
  //   }
  //   return null;
  // }

}
